export default __webpack_public_path__ + "static/media/pg-12.dfb5cdfd.jpg";